import React from 'react';

const HeroSection = () => {
  return (
    <section className="w-full bg-white">
      {/* Hero Video */}
      <div className="w-full flex justify-center px-4 py-8">
        <video
          autoPlay
          muted
          loop
          playsInline
          controls
          className="w-full max-w-5xl h-auto rounded-lg shadow-lg"
        >
          <source 
            src="https://assets.cdn.filesafe.space/nkLYw11gSMHWieNYss1h/media/68c8216857da567e97f85d5a.mp4" 
            type="video/mp4" 
          />
          Your browser does not support the video tag.
        </video>
      </div>
    </section>
  );
};

export default HeroSection;
